import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_PROJECTS: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_PROJECTS_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_PROJECTS_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.PROJECT_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.PROJECT_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.PROJECT_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.PROJECT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.PROJECT_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
